import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Category from './views/Category.vue'
import { DictionaryEntry, DictionaryCategory } from './dictionary'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/category/:category',
      name: 'category',
      component: Category,
      props: route => ({ 
        filter: (entry: DictionaryEntry) => entry.category.includes(route.params.category as DictionaryCategory), 
        displayCategory: false,
      })
    },
    {
      path: '/todo',
      name: 'todo',
      component: () => import('./views/Todo.vue')
    }
  ]
})
